import { render } from "./ClientPayments.vue?vue&type=template&id=47973fb2&scoped=true"
import script from "./ClientPayments.vue?vue&type=script&lang=js"
export * from "./ClientPayments.vue?vue&type=script&lang=js"

import "./ClientPayments.vue?vue&type=style&index=0&id=47973fb2&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47973fb2"]])

export default __exports__